import { Box, Text, dimensions } from '@factorialco/deprecated-design-system'
import { PieTooltipProps, ResponsivePie } from '@nivo/pie'

import i18n from 'modules/core/lib/i18n'

import { buildTheme } from './theme'

const HEIGHT = 520

const MARGIN = {
  top: 80,
  right: 40,
  bottom: 80,
  left: 40,
}

export interface Data {
  id: string
  label: string
  value: number
}

const CustomTooltip = ({ datum }: PieTooltipProps<Data>) => (
  <Box paddingX="s12" paddingY="s8" background="grey000White" boxShadow="s100">
    <Text.Normal>
      {i18n.tView('surveys.analytics.charts.tooltip', {
        value: <strong>{datum.label}</strong>,
        count: <span>{datum.value}</span>,
      })}
    </Text.Normal>
  </Box>
)

interface Props {
  data: Data[]
  onClick?: (label: string) => void
}

const Pie = ({ data, onClick }: Props) => {
  return (
    <Box
      padding="s16"
      background="grey000White"
      style={{
        // This is a hack so the chart has enough space:
        height: `calc(${HEIGHT + 'px'} + ${dimensions.s32}`,
      }}
    >
      <ResponsivePie
        data={data}
        theme={buildTheme()}
        colors={{ scheme: 'set3' }}
        margin={MARGIN}
        arcLinkLabelsSkipAngle={10}
        tooltip={CustomTooltip}
        onMouseEnter={
          onClick
            ? (_datum, event) => ((event.target as SVGRectElement).style.cursor = 'pointer')
            : undefined
        }
        onMouseLeave={
          onClick
            ? (_datum, event) => ((event.target as SVGRectElement).style.cursor = 'normal')
            : undefined
        }
        onClick={onClick ? ({ data }) => onClick(data.label || '0') : undefined}
      />
    </Box>
  )
}

export default Pie
